import { AdminField } from 'components/shared/dropdowns'
import { AllTodosDocument, useQuickAssignFirstOwnerMutation } from 'graphql/bindings/AdminBindings'
import { Box, FormModal, FormSectionTitle, SpinnerButton } from '@forgeglobal/design-framework'
import { Form, FormRenderProps } from 'react-final-form'
import { MutationResult } from 'react-apollo'
import React from 'react'

type FormShape = {
  owner?: { label: string; value: number }
  mutationResult: MutationResult
}

export const ClaimAccountForm: React.FC<FormRenderProps<FormShape>> = ({ handleSubmit, values, valid }) => {
  const mutateInProgress = values.mutationResult.called
  return (
    <form onSubmit={handleSubmit}>
      <AdminField name="owner" label="Owner" />
      <Box mt={2}>
        <SpinnerButton
          variant="contained"
          color="primary"
          type="submit"
          fullWidth
          disabled={!valid}
          loading={mutateInProgress}
          caption="Save"
        />
      </Box>
    </form>
  )
}

interface ClaimAccountModalProps {
  hideModal: () => void
  accountId: string
  accountName: string
}

export const ClaimAccountModal: React.FC<ClaimAccountModalProps> = ({ accountId, accountName, hideModal }) => {
  const [mutate, mutationResult] = useQuickAssignFirstOwnerMutation({
    refetchQueries: [{ query: AllTodosDocument }],
    onCompleted: hideModal,
  })
  const onSubmit = (values: FormShape) => {
    if (values.owner) {
      mutate({
        variables: { accountId: accountId, ownerId: values.owner.value },
      })
    }
  }

  const initialValues: FormShape = {
    mutationResult,
  }

  return (
    <FormModal open hideModal={hideModal} title="Assign Owner">
      <FormSectionTitle>Assign ownership of {accountName} to:</FormSectionTitle>
      <Form component={ClaimAccountForm} onSubmit={onSubmit} initialValues={initialValues} />
    </FormModal>
  )
}
